import React from 'react';

import { useIntl } from '@utils/intl';
import { BookingIcon } from '@views/shared/BookingIcon';
import { BOOK_CATEGORY_ROOM, getBookingIcon } from '@views/shared/consts';
import { Panel } from '@views/Book/Bookings/Panel';

import { useDesks } from './hooks';

const getCountDesc = (count = 0) => {
  const translation = 'views.Home.Bookings.Desks.total';
  const templateVars = { totalDesks: count };

  return {
    translation,
    templateVars,
  };
};

export default function Desks() {
  const { t } = useIntl();
  const errorMessage = t('views.Home.Bookings.Desks.hooks.desksDataFail');

  const {
    numberOfDesks,
    loading,
    error,
    favCount,
    goToFavourites,
    goToStructure,
    worklightStatus,
  } = useDesks(BOOK_CATEGORY_ROOM, errorMessage);

  const name = t('views.Home.Bookings.Desks.shared');
  const { translation, templateVars } = getCountDesc(numberOfDesks);

  if (error) {
    return null;
  }

  return (
    <Panel
      loading={loading}
      text={t(translation, templateVars)}
      favs={favCount}
      icon={
        <BookingIcon
          name={getBookingIcon(BOOK_CATEGORY_ROOM)}
          worklight={worklightStatus}
        />
      }
      name={name}
      onFavsPress={goToFavourites}
      onAction={goToStructure}
    />
  );
}
